import VisuallySimilar from './VisuallySimilar'

export default VisuallySimilar
